import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import getDataRange from '../../../helpers/getDataRange';
import moment from 'moment';
import { parseLocalDate } from '../../../helpers/date';

const DateRangePicker = (props) => {
    const { start_date, end_date } = window?.filters?.filters?.dates?.values;
    const dates = window?.filters?.filters?.dates;
    const [startDate, setStartDate] = useState(
        parseLocalDate(props.defaultStartDate ?? start_date?.value),
    );
    const [endDate, setEndDate] = useState(parseLocalDate(props.defaultEndDate ?? end_date?.value));
    const [selectedOption, setSelectedOption] = useState(dates || {});
    const countFromToday = props.is_from_tools || props.is_from_ai_tracking;
    const setRange = (range) => {
        setSelectedOption(range);
        const { start_date, end_date } = getDataRange(range, countFromToday, props.maxDate);
        setStartDate(parseLocalDate(start_date.value));
        setEndDate(parseLocalDate(end_date.value));
    };

    const onChangeTime = (date) => {
        let startDate = date[0];
        let endDate = date[1];
        if (props.gsc_report && endDate) {
            const endOfWeek = moment(date[1]).endOf('week').toDate();
            endDate = endOfWeek;
        }

        setStartDate(startDate);
        setEndDate(endDate);
        const choice = {
            label: 'Custom',
            key: 'dates',
            id: 'custom',
            values: {
                start_date: { value: startDate },
                end_date: { value: endDate },
            },
        };
        setSelectedOption(choice);
    };

    const onChange = (key, value) => {
        let choice = {};
        if (key === 'start') {
            choice = {
                label: 'Custom',
                key: 'dates',
                id: 'custom',
                values: {
                    start_date: { value: value },
                    end_date: selectedOption?.values?.end_date,
                },
            };
            setStartDate(value);
        } else {
            choice = {
                label: 'Custom',
                key: 'dates',
                id: 'custom',
                values: {
                    start_date: selectedOption?.values?.start_date,
                    end_date: { value: value },
                },
            };
            setEndDate(value);
        }
        setSelectedOption(choice);
    };

    const onApply = () => {
        const choiceValue = getDataRange(selectedOption, countFromToday, props.maxDate);
        const selectedChoice = { ...selectedOption, values: choiceValue };
        props.updateSelect(selectedChoice);
        props.onClose();
    };

    const options = [...props.options];
    options.unshift({
        label: 'Custom',
        key: 'dates',
        id: 'custom',
        values: {
            start_date: null,
            end_date: null,
        },
    });

    return (
        <>
            <div className={`date-picker-container ${props.gsc_report ? 'from-gsc-reports' : ''}`}>
                {/* Sidebar with predefined date ranges */}
                <div className="date-picker-sidebar">
                    {options.map((range) => (
                        <button
                            key={range.id}
                            className={`date-range-button ${
                                range.id === selectedOption?.id ? 'active' : ''
                            }`}
                            onClick={() => setRange(range)}
                        >
                            {range.label}
                        </button>
                    ))}
                </div>

                {/* Date Picker section */}
                <div className="date-picker-content">
                    <h3 className="date-picker-title">Analyze Content</h3>
                    <div className="date-picker-inputs">
                        <div>
                            <label>Start Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => onChange('start', date)}
                                className="date-input"
                                open={false}
                                minDate={props.minDate ? parseLocalDate(props.minDate) : null}
                                maxDate={props.maxDate ? parseLocalDate(props.maxDate) : null}
                            />
                        </div>
                        <div>
                            <label>End Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => onChange('end', date)}
                                className="date-input"
                                open={false}
                                minDate={props.minDate ? parseLocalDate(props.minDate) : null}
                                maxDate={props.maxDate ? parseLocalDate(props.maxDate) : null}
                            />
                        </div>
                    </div>

                    {/* Centered Calendar */}
                    <div className="date-picker-calendar">
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => onChangeTime(date)}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            inline
                            minDate={props.minDate ? parseLocalDate(props.minDate) : null}
                            maxDate={props.maxDate ? parseLocalDate(props.maxDate) : null}
                            showWeekNumbers={props.gsc_report}
                            showWeekPicker={props.gsc_report}
                            preventKeyboardNavigation
                        />
                    </div>

                    {/* Buttons */}
                    <div className="date-picker-buttons">
                        <button
                            className="clear-button"
                            onClick={() => {
                                setStartDate(null);
                                setEndDate(null);
                            }}
                        >
                            Clear
                        </button>
                        <button
                            className="analyze-button"
                            onClick={onApply}
                            disabled={!startDate || !endDate}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DateRangePicker;
